import React, { useContext } from 'react';
import Header from '../../components/Header/Header';
import useTranslation from '../../hooks/useTranslation';
import { TranslationContext } from '../../helpers/Context';
import './privacy-policy.css';

const PrivacyPolicy = () => {
  const T = useTranslation();
  const { language } = useContext(TranslationContext);

  // Datos de las secciones de la política de privacidad
  const privacySections = [
    {
      title: 'privacy_section_1_title',
      content: 'privacy_section_1_content',
      icon: '🔒'
    },
    {
      title: 'privacy_section_2_title',
      content: 'privacy_section_2_content',
      icon: '📊'
    },
    {
      title: 'privacy_section_3_title',
      content: 'privacy_section_3_content',
      icon: '🎯'
    },
    {
      title: 'privacy_section_4_title',
      content: 'privacy_section_4_content',
      icon: '🍪'
    },
    {
      title: 'privacy_section_5_title',
      content: 'privacy_section_5_content',
      icon: '⚖️'
    },
    {
      title: 'privacy_section_6_title',
      content: 'privacy_section_6_content',
      icon: '📝'
    }
  ];

  const renderPrivacySection = (section, index) => (
    <div key={index} className="privacy-section">
      <h3 className="privacy-section-title">
        <div className="privacy-section-icon">{section.icon}</div>
        {T(section.title)}
      </h3>
      <div className="privacy-section-content">
        <p>{T(section.content)}</p>
      </div>
    </div>
  );

  return (
    <div>
      <Header />
      <div className="privacy-policy-container">
        <h1 className="privacy-policy-title">{T('privacy_policy_title')}</h1>
        <p className="privacy-policy-description">{T('privacy_policy_description')}</p>
        
        <div className="privacy-policy-content">
          {privacySections.map((section, index) => 
            renderPrivacySection(section, index)
          )}
          
          <div className="privacy-footer">
            <p className="privacy-last-updated">
              {T('privacy_last_updated')} <span className="privacy-date">Diciembre 2024</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy; 